import axios from "axios";
import server from "../server.js";

const state = {
    loading: false,
    error: {},
    experts: [],
    cabinets: [],
    agendas: [],
    status: "",
};
const getters = {
    getExperts(context) {
        return context.experts;
    },
    getCabinets(context) {
        return context.cabinets;
    },
    getAgendas(context) {
        return context.agendas;
    },
    getStatus(context) {
        return context.status;
    },
};

const mutations = {
    UPDATE_EXPERTS(state, payload) {
        state.experts = payload.data.experts;
    },
    UPDATE_CABINETS(state, payload) {
        state.cabinets = payload.data.endUsers;
    },
    UPDATE_AGENDAS(state, payload) {
        state.agendas = payload.data.agendas;
    },
    UPDATE_LOADING(state, enabled) {
        state.loading = enabled;
    },
    UPDATE_STATUS(state, status) {
        state.status = status;
    },
};

const actions = {
    async getExperts(context) {
        context.commit("UPDATE_LOADING", true);
        context.commit("UPDATE_STATUS", "");
        let res = await axios({
            method: "GET",
            url: server.url + server.urls.expert,
            headers: server.getHeader(),
        });
        context.commit("UPDATE_EXPERTS", res.data);
        context.commit("UPDATE_LOADING", false);
    },
    async getCabinets(context, param) {
        context.commit("UPDATE_LOADING", true);
        context.commit("UPDATE_STATUS", "");
        const expertCompanyId = context.state.experts?.find(
            (v) => v.name == param
        )?.companyID;
        let res = await axios({
            method: "GET",
            url:
                server.url +
                server.urls.expert +
                "/" +
                expertCompanyId +
                "/collective-end-users",
            headers: server.getHeader(),
        });
        context.commit("UPDATE_CABINETS", res.data);
        context.commit("UPDATE_LOADING", false);
    },
    async getAgendas(context) {
        context.commit("UPDATE_LOADING", true);
        context.commit("UPDATE_STATUS", "");
        let res = await axios({
            method: "GET",
            url: server.url + server.urls.agenda,
            headers: server.getHeader(),
        });
        context.commit("UPDATE_AGENDAS", res.data);
        context.commit("UPDATE_LOADING", false);
    },
    async activateAgenda(context, params) {
        context.commit("UPDATE_LOADING", true);
        context.commit("UPDATE_STATUS", "");
        let res = await axios({
            method: "POST",
            url: server.url + server.urls.agenda,
            headers: server.getHeader(),
            data: { ...params },
        });
        context.commit("UPDATE_STATUS", res.data.success ? "✓" : "✖︎");
        context.commit("UPDATE_LOADING", false);
    },
    async updateAgenda(context, params) {
        context.commit("UPDATE_LOADING", true);
        context.commit("UPDATE_STATUS", "");
        let res1 = await axios({
            method: "PATCH",
            url: server.url + server.urls.agenda + "/" + params.licenceId,
            headers: server.getHeader(),
            data: { ...params },
        });
        context.commit("UPDATE_STATUS", res1.data.success ? "✓" : "✖︎");
        let res2 = await axios({
            method: "GET",
            url: server.url + server.urls.agenda,
            headers: server.getHeader(),
        });
        context.commit("UPDATE_AGENDAS", res2.data);
        context.commit("UPDATE_LOADING", false);
    },
};

const store = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};

export default store;
